// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"image_placeholder__N7zYI","feature":"image_feature__9QKxJ","square":"image_square__lqd8p","poster":"image_poster__8UTn8","standard":"image_standard__pcBrP"};